<p-calendar v-model="proxyDate" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>